import { useContext, useEffect, useState } from 'react';
import { toast } from '../../util/toasts';
import { TenantContext } from '../../context/tenant-context';
import { useCustomerAPI } from '../../clients/customer-api/customer-api-client';
import { DateTime } from 'luxon';
import { UserDocument, UserDocumentType, UserDriverLic } from '../../clients/quipli-service/user/user';
import { LicenseDetails } from './license-details';
import { Spinner } from '../../components/spinner/spinner';
import { Typography } from '../../components/typography/typography';
import { EcommerceButton } from '../../components/form/button';

export const LicenseDetailsWrapper = () => {
  const { contextPath } = useContext(TenantContext);
  const { getUserDriverLicense, getUserDocumentByType } = useCustomerAPI();

  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [userLicenseDetails, setUserLicenseDetails] = useState<UserDriverLic | undefined>();
  const [userLicenseFile, setUserLicenseFile] = useState<UserDocument>();
  const [licenseScanRequired, setLicenseScanRequired] = useState<boolean>(false);

  useEffect(() => {
    setIsLoading(true);

    fetchLicenseDetails()
      .then(() => setIsLoading(false))
      .catch(() => {
        toast('Failed to get license details', 'error');
        setIsLoading(false);
      });
  }, []);

  const fetchLicenseDetails = async () => {
    const [licenseDetails, licenseFile] = await Promise.all([
      getUserDriverLicense(),
      getUserDocumentByType(UserDocumentType.License),
    ]);

    setLicenseScanRequired(licenseDetails === undefined || licenseDetails.expirationDate < DateTime.local());

    setUserLicenseDetails(licenseDetails);
    setUserLicenseFile(licenseFile);
  };

  const redirectLicenseScan = () => {
    window.location.href = `${window.location.origin}${contextPath}account/scan_license`;
  };

  return isLoading ? (
    <Spinner />
  ) : (
    <div>
      {userLicenseDetails && !licenseScanRequired ? (
        <LicenseDetails userLicenseDetails={userLicenseDetails} userLicenseFile={userLicenseFile} />
      ) : (
        <>
          <div>
            <Typography type="text-md" className="text-grey-600">
              Please scan your driver's license in order to be able to place your order request with us.
            </Typography>
          </div>
          <div className="justify-content-left pt-3">
            <EcommerceButton buttonStyle="primary" onClick={redirectLicenseScan}>
              <Typography type="text-md" weight="medium">
                Scan License
              </Typography>
            </EcommerceButton>
          </div>
        </>
      )}
    </div>
  );
};
